import { MapPinIcon } from "@heroicons/react/24/solid"
import { useState } from "react"
import { FieldError, UseFormGetValues, UseFormSetValue } from "react-hook-form"
import { autoCompleteFields } from "utils"

export const InputPostalCode = ({ register, required, errors, setValue, getValues, setError }:
  {
    register: any, required: boolean | string,
    errors: FieldError | undefined, setValue: UseFormSetValue<any>,
    getValues: UseFormGetValues<any>, setError: any
  }) => {
  const [postalValue, setPostalValue] = useState<string>("")
  return (
    <>
      <div className="flex items-center" style={{ marginBottom: 6 }}>
        <label htmlFor="postal_code" className="block text-sm font-bold text-gray-800">
          郵便番号
        </label>
        {required &&
          <span className="ml-2 text-xs font-extrabold rounded px-1.5 py-0.5" style={{ color: "#FF4D2D", background: "#FFE9E1" }}>
            必須
          </span>
        }
      </div>
      <div className="grid grid-cols-4 gap-2">
        <div className="col-span-4 sm:col-span-3 relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <MapPinIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            className="h-11 px-2 focus:ring-[#FF4D2D] focus:border-[#FF4D2D] block w-full pl-10 sm:text-sm border-gray-200 rounded-xl"
            {
            ...register("postal_code", {
              required: required,
              maxLength: { value: 8, message: "郵便番号が長すぎます" },
              minLength: { value: 6, message: "郵便番号が短すぎます" },
              pattern: {
                value: /^[0-9]+$/,
                message: "郵便番号の形式が不正です。",
              }
            })
            }
            onChange={(e) => { setPostalValue(e.target.value);}}
            id="postal_code"
            autoComplete={"postal-code"}
            placeholder={"例) 0993225"}
          />
        </div>
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); autoCompleteFields(postalValue, setValue, setError); }}
          className="col-span-4 sm:col-span-1 inline-flex items-center justify-center h-11 w-full text-white text-sm font-extrabold rounded-full cursor-pointer"
          style={{ background: "#FF4D2D", boxShadow: "0 8px 18px rgba(255,77,45,0.28)" }}
        >
          住所の自動検索
        </button>
      </div>
      {errors && <p className="text-red-600 text-xs">{errors.message}</p>}
  </>
  )
}